export default __webpack_public_path__ + "static/AmericanaStd-Roman-caf5843376a0ef85b4bdcd82c28ba244.woff";